import api from './api';

/**
 * Servicio de Previred
 * Centraliza las llamadas API para facilitar futura migración a MCP
 */

export const getEstadoPeriodo = (idCompany, mes, anio) =>
  api.get('/api/rrhh/previred/estado-periodo', {
    params: { id_company: idCompany, mes, anio }
  }).then(r => r.data.data);

export const descargarTxt = async (idCompany, mes, anio) => {
  const response = await api.get('/api/rrhh/previred/descargar-txt', {
    params: { id_company: idCompany, mes, anio },
    responseType: 'blob'
  });
  const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `previred_${String(mes).padStart(2, '0')}_${anio}.txt`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const subirPdf = (idCompany, mes, anio, file) => {
  const formData = new FormData();
  formData.append('pdf', file);
  formData.append('id_company', idCompany);
  formData.append('periodo_mes', mes);
  formData.append('periodo_anio', anio);
  return api.post('/api/rrhh/previred/extract-from-pdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

export const getDetallePdf = (id) =>
  api.get(`/api/rrhh/previred/auditoria/${id}`).then(r => r.data.data);

export const eliminarPdf = (id) =>
  api.delete(`/api/rrhh/previred/auditoria/${id}`).then(r => r.data);

export const cambiarEstado = (id, estado) =>
  api.patch(`/api/rrhh/previred/auditoria/${id}/estado`, { estado }).then(r => r.data);

export const reprocesarPdf = (id) =>
  api.post(`/api/rrhh/previred/auditoria/${id}/reprocesar`).then(r => r.data);
